import type { Namespace } from '../types';

// Asset Lifecycle / CMDB (R-063). DE drafted — queued for native review in
// the i18n task file's "DE review queue".
export const assets = {
  title: { de: 'Asset Lifecycle', en: 'Asset Lifecycle' },
  desc: {
    de: 'Anlagenregister — Lebenszyklus, Zustand und Stammdaten aller physischen Assets.',
    en: 'Asset register — lifecycle, health and master data of every physical asset.',
  },

  tabAssets: { de: 'Assets', en: 'Assets' },
  tabTypes: { de: 'Asset-Typen', en: 'Asset types' },

  // Stats (AST-013)
  statOperational: { de: 'Betriebsbereit', en: 'Operational' },
  statDegraded: { de: 'Beeinträchtigt', en: 'Degraded' },
  statFault: { de: 'Störung', en: 'Fault' },
  statOffline: { de: 'Offline', en: 'Offline' },
  statStock: { de: 'Im Lager', en: 'In stock' },

  // Statuses
  statusOperational: { de: 'Betriebsbereit', en: 'Operational' },
  statusDegraded: { de: 'Beeinträchtigt', en: 'Degraded' },
  statusFault: { de: 'Störung', en: 'Fault' },
  statusOffline: { de: 'Offline', en: 'Offline' },

  // Phases (AST-024)
  phaseLager: { de: 'Im Lager', en: 'In stock' },
  phaseAssigned: { de: 'Zugewiesen', en: 'Assigned' },
  phaseBetrieb: { de: 'In Betrieb', en: 'In operation' },
  phaseDecommissioned: { de: 'Außer Betrieb', en: 'Decommissioned' },
  phaseAll: { de: 'Alle Phasen', en: 'All phases' },

  // Categories
  catHvac: { de: 'HVAC / Klima', en: 'HVAC / Climate' },
  catLighting: { de: 'Beleuchtung', en: 'Lighting' },
  catWater: { de: 'Wasser & Fertigation', en: 'Water & Fertigation' },
  catSensor: { de: 'Sensorik', en: 'Sensors' },
  catCamera: { de: 'Kameras', en: 'Cameras' },
  catAirlock: { de: 'Airlock', en: 'Airlock' },
  catPower: { de: 'Strom & Edge', en: 'Power & Edge' },

  // Impact (AST-027)
  impact: { de: 'Business Impact', en: 'Business impact' },
  impactCritical: { de: 'Kritisch', en: 'Critical' },
  impactHigh: { de: 'Hoch', en: 'High' },
  impactMedium: { de: 'Mittel', en: 'Medium' },
  impactLow: { de: 'Niedrig', en: 'Low' },

  // List + filters
  searchPlaceholder: { de: 'Tag, Klasse oder Seriennummer…', en: 'Tag, class or serial…' },
  colAsset: { de: 'Asset', en: 'Asset' },
  colClass: { de: 'Klasse', en: 'Class' },
  colRoom: { de: 'Raum', en: 'Room' },
  colPhase: { de: 'Phase', en: 'Phase' },
  colStatus: { de: 'Status', en: 'Status' },
  colWarranty: { de: 'Garantie', en: 'Warranty' },
  emptyTitle: { de: 'Keine Assets', en: 'No assets' },
  emptyMsg: {
    de: 'Assets werden per Wareneingang angelegt — „Wareneingang" oben rechts.',
    en: 'Assets are created via goods receipt — "Goods receipt" top right.',
  },
  open: { de: 'Öffnen', en: 'Open' },

  // Goods receipt (AST-020)
  newAsset: { de: 'Neues Asset', en: 'New asset' },
  grTitle: { de: 'Wareneingang — neues Asset', en: 'Goods receipt — new asset' },
  assetTag: { de: 'Asset-Tag', en: 'Asset tag' },
  egAssetTag: { de: 'z. B. AST-HV-042', en: 'e.g. AST-HV-042' },
  assetType: { de: 'Asset-Typ', en: 'Asset type' },
  selectType: { de: 'Typ wählen…', en: 'Select a type…' },
  serial: { de: 'Seriennummer', en: 'Serial number' },
  storageLocation: { de: 'Lagerort', en: 'Storage location' },
  selectStorage: { de: 'Lagerort wählen…', en: 'Select storage location…' },
  noWarehousesHint: {
    de: 'Noch keine Lager angelegt — zuerst unter Commerce → Warehouse eines anlegen.',
    en: 'No warehouses yet — create one under Commerce → Warehouse first.',
  },
  noRoomsHint: {
    de: 'Noch keine Grow Rooms registriert — zuerst im Mapper anlegen.',
    en: 'No grow rooms registered yet — create one in the Mapper first.',
  },
  purchaseDate: { de: 'Kaufdatum', en: 'Purchase date' },
  cost: { de: 'Kosten (€)', en: 'Cost (€)' },
  comment: { de: 'Kommentar', en: 'Comment' },
  create: { de: 'Anlegen', en: 'Create' },
  toastCreated: { de: 'Asset {tag} angelegt', en: 'Asset {tag} created' },

  // Record page (AST-030/031)
  recordCrumb: { de: 'Asset-Akte', en: 'Asset record' },
  tabGeneral: { de: 'Allgemein', en: 'General' },
  tabFinancial: { de: 'Finanzen', en: 'Financial' },
  tabHistory: { de: 'Historie', en: 'History' },
  notFound: { de: 'Asset nicht gefunden.', en: 'Asset not found.' },
  configurationItem: { de: 'Configuration Item', en: 'Configuration item' },
  modelCategory: { de: 'Modell-Kategorie', en: 'Model category' },
  manufacturer: { de: 'Hersteller', en: 'Manufacturer' },
  room: { de: 'Raum', en: 'Room' },
  linkedMc: { de: 'Verknüpfter Controller', en: 'Linked controller' },
  receivedAt: { de: 'Wareneingang am', en: 'Received on' },
  commissionedAt: { de: 'In Betrieb seit', en: 'Commissioned on' },
  decommissionedAt: { de: 'Außer Betrieb seit', en: 'Decommissioned on' },
  warranty: { de: 'Garantie', en: 'Warranty' },
  warrantyValid: { de: 'Gültig bis {date}', en: 'Valid until {date}' },
  warrantyExpired: { de: 'Abgelaufen am {date}', en: 'Expired on {date}' },
  warrantyUnknown: { de: 'Kein Kaufdatum hinterlegt', en: 'No purchase date on record' },
  toastSaved: { de: 'Asset gespeichert', en: 'Asset saved' },
  editAsset: { de: 'Asset bearbeiten', en: 'Edit asset' },
  mcRefHint: {
    de: 'Geräte-ID des Controllers (Mikrocontroller-ID) — verknüpft den Live-Status aus dem Health-Feed.',
    en: "The controller's device id (microcontroller id) — links the live status from the health feed.",
  },

  // Lifecycle actions (AST-021/022)
  actions: { de: 'Aktionen', en: 'Actions' },
  assignToRoom: { de: 'Raum zuweisen', en: 'Assign to room' },
  commission: { de: 'In Betrieb nehmen', en: 'Commission' },
  checkIn: { de: 'Zurück ins Lager', en: 'Return to stock' },
  decommission: { de: 'Außer Betrieb nehmen', en: 'Decommission' },
  roomCode: { de: 'Raum-Code', en: 'Room code' },
  selectRoom: { de: 'Raum wählen…', en: 'Select room…' },
  transitionTitle: { de: 'Lebenszyklus — {tag}', en: 'Lifecycle — {tag}' },
  toastTransitioned: { de: 'Asset in „{phase}" überführt', en: 'Asset moved to "{phase}"' },
  setStatus: { de: 'Status setzen', en: 'Set status' },
  toastStatus: { de: 'Status gesetzt', en: 'Status set' },
  deleteAsset: { de: 'Asset löschen', en: 'Delete asset' },
  deleteAssetTitle: { de: '{tag} löschen?', en: 'Delete {tag}?' },
  deleteAssetMsg: {
    de: 'Das Asset und seine gesamte Historie werden endgültig gelöscht.',
    en: 'The asset and its full history will be permanently deleted.',
  },
  toastDeleted: { de: 'Asset gelöscht', en: 'Asset deleted' },

  // Event history kinds
  evGoodsReceipt: { de: 'Wareneingang', en: 'Goods receipt' },
  evPhaseLager: { de: 'Zurück ins Lager', en: 'Returned to stock' },
  evPhaseAssigned: { de: 'Raum zugewiesen', en: 'Assigned to room' },
  evPhaseBetrieb: { de: 'In Betrieb genommen', en: 'Commissioned' },
  evPhaseDecommissioned: { de: 'Außer Betrieb genommen', en: 'Decommissioned' },
  evStatusChange: { de: 'Statuswechsel', en: 'Status change' },
  noEvents: { de: 'Noch keine Ereignisse.', en: 'No events yet.' },

  // Type manager (AST-023/028)
  newType: { de: 'Neuer Typ', en: 'New type' },
  editType: { de: 'Asset-Typ bearbeiten', en: 'Edit asset type' },
  colCategory: { de: 'Kategorie', en: 'Category' },
  colSpareSku: { de: 'Ersatzteil-SKU', en: 'Spare SKU' },
  colMinStock: { de: 'Mindestbestand', en: 'Min stock' },
  colStock: { de: 'Bestand', en: 'Stock' },
  colWarrantyMonths: { de: 'Garantie (Monate)', en: 'Warranty (months)' },
  className: { de: 'Klassenname', en: 'Class name' },
  egClassName: { de: 'z. B. LED-Wachstumslampe', en: 'e.g. LED grow light' },
  approverFunctional: { de: 'Fachlicher Approver', en: 'Functional approver' },
  tracked: { de: 'Bestand überwachen', en: 'Track stock' },
  trackedHint: {
    de: 'Unterschreitet der Lagerbestand den Mindestbestand, folgt später die automatische Nachbestellung (Procurement).',
    en: 'When stock falls below the minimum, automatic reordering follows later (Procurement).',
  },
  typesEmptyTitle: { de: 'Keine Asset-Typen', en: 'No asset types' },
  typesEmptyMsg: {
    de: 'Typen sind der Auswahlkatalog beim Wareneingang — zuerst hier anlegen.',
    en: 'Types are the pick catalog for goods receipt — create them here first.',
  },
  toastTypeSaved: { de: 'Asset-Typ gespeichert', en: 'Asset type saved' },
  deleteTypeTitle: { de: '{name} löschen?', en: 'Delete {name}?' },
  deleteTypeMsg: {
    de: 'Nur möglich, wenn keine Assets diesen Typ verwenden.',
    en: 'Only possible while no assets use this type.',
  },
  toastTypeDeleted: { de: 'Asset-Typ gelöscht', en: 'Asset type deleted' },
} as const satisfies Namespace;
